import { Image as ImageType } from 'models'
import { PictureIndications } from './types'
import { isNull } from 'utilities'

export const getImageOrientation = img => {
  let orientation = 'even'

  if (img.naturalWidth > img.naturalHeight) {
    orientation = 'landscape'
  } else if (img.naturalWidth < img.naturalHeight) {
    orientation = 'portrait'
  }

  return orientation
}

export const getImageInfo = src => {
  const img = new Image()
  img.src = src
  return img
}

export const getPictureIndications = (image: ImageType): PictureIndications => {
  const {
    portrait, portraitWidth, portraitX, portraitY,
    square, squareWidth, squareX, squareY
  } = image

  const portraitCrop = !isNull(portraitWidth) && !isNull(portraitX) && !isNull(portraitY)
  const squareCrop = !isNull(squareWidth) && !isNull(squareX) && !isNull(squareY)

  return {
    portraitCrop,
    portraitForGeneralUse: !!portrait,
    squareCrop,
    squareForGeneralUse: !!square
  }
}
